class FooterRoot extends HTMLElement {
  constructor() {
    super();
    this.showOnScroll = this.dataset.showOnScroll === 'true';
    this.isMobile = window.innerWidth < 750;
    this.idleTimer = null;
    this.IDLE_TIMEOUT = 2000; // ms before footer hides after scroll stops

    this.footerContainer = this.querySelector('.footer-container');
    this.mainContent = document.getElementById('MainContent');

    this.initResizeObserver();
    this.updateFooterHeight();
    this.initScrollBehavior();

    // Re-evaluate on resize (desktop ↔ mobile breakpoint)
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 750;
      if (wasMobile !== this.isMobile) {
        this.updateFooterHeight();
        if (!this.isMobile) {
          // Switched to desktop — ensure footer is visible and reset
          this.classList.remove('footer--visible');
          clearTimeout(this.idleTimer);
        }
      }
    });
  }

  initResizeObserver() {
    if (!this.footerContainer) return;
    this.resizeObserver = new ResizeObserver(() => this.updateFooterHeight());
    this.resizeObserver.observe(this.footerContainer);
  }

  updateFooterHeight() {
    if (!this.footerContainer) return;
    const height = this.footerContainer.offsetHeight;

    if (this.isMobile && this.showOnScroll) {
      // Mobile slide-up mode: footer floats over content, doesn't consume layout space
      document.documentElement.style.setProperty('--footer-height', '0px');
      document.documentElement.style.setProperty('--footer-actual-height', `${height}px`);
    } else {
      // Desktop or setting OFF: footer is always visible, reserve space
      document.documentElement.style.setProperty('--footer-height', `${height}px`);
      document.documentElement.style.setProperty('--footer-actual-height', `${height}px`);
    }
  }

  initScrollBehavior() {
    if (!this.showOnScroll || !this.mainContent) return;

    // Listen to #MainContent scroll (Lenis scroll container)
    this.mainContent.addEventListener('scroll', () => {
      if (!this.isMobile) return;

      const scrollTop = this.mainContent.scrollTop;

      if (scrollTop > 10) {
        // User is scrolling — show footer
        this.classList.add('footer--visible');

        // Reset idle timer
        clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(() => {
          this.classList.remove('footer--visible');
        }, this.IDLE_TIMEOUT);
      } else {
        // At or near the top — hide footer
        this.classList.remove('footer--visible');
        clearTimeout(this.idleTimer);
      }
    }, { passive: true });
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    clearTimeout(this.idleTimer);
  }
}

customElements.define('footer-root', FooterRoot);
